module.exports = __webpack_public_path__ + "static/media/41.17e31426.png";